"use client";
import { ExtractBySectionType, ExtractPropertyType, SectionType } from "types";
import { ContactCards } from "./contact-cards";

export type ContactsType = ExtractBySectionType<
  SectionType,
  "contactsSection",
  "_type"
>;

export type ContactCardsType = NonNullable<
  ExtractPropertyType<ContactsType, "contactCards">
>[number];

export type SocialLinkType = ExtractPropertyType<
  ContactCardsType,
  "socialLinks"
>;

export type LocationInfoType = ExtractPropertyType<
  ContactCardsType,
  "locationInfo"
>;

export function ContactsSection({ data }: { data: ContactsType }) {
  const { title, description, contactCards } = data;

  return (
    <section className="py-20 px-10 sm:px-24 mb-12 bg-white">
      <div className="text-center md:text-start max-w-screen-2xl mx-auto px-6 md:px-8">
        {title && (
          <h3 className="font-medium text-[#0D0D0D] text-2xl lg:text-4xl leading-[120%] font-outfit">
            {title}
          </h3>
        )}
        {description && (
          <p className="text-sm lg:text-base text-gray-600 mt-2">
            {description}
          </p>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:w-full">
          {contactCards?.map((card, index) => (
            <ContactCards data={card} key={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
